// React
import { createContext } from "react"

export const DataContextCreateBy = createContext<{
  created_by: number
}>({
  created_by: 0
})